import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth-service.component';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-signout-callback',
  template: `<div></div>`
})

export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(private _authService: AuthService,
              private _router: Router,
              private _cookieService: CookieService) { }

  ngOnInit() {
    this._authService.completeLogout().then(_ => {
      let isAppLoaded = this._cookieService.remove("__isAppLoaded");
      this._router.navigate(['/login'], { replaceUrl: true });
    })
  }
}